import { type UseQueryResult, useQuery } from 'react-query';
import { NoticeService } from '../../services/wealthlane-award-services/services/NoticeService';
import type { Wealthlane_AwardService_Dtos_Notices_FileContentDto } from '../../services/wealthlane-award-services';

const useGetGrantAcceptancePdf = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  awardId?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Notices_FileContentDto | undefined,
  unknown
> => {
  const grantAcceptancePdf = useQuery(['getGrantAcceptancePdf', awardId], async () => {
    if (awardId) {
      return await handleRequest(NoticeService.getApiAwardApiNoticesGrantAcceptancePdf(awardId));
    }
  });

  return grantAcceptancePdf;
};

export default useGetGrantAcceptancePdf;
